import styled from 'styled-components';
import ColorPicker from 'components/composer/shared/color_picker';

export const StyledColorPickerToolbarDropdown = styled(ColorPicker)`
  padding-left: 6px;
  padding-right: 6px;
  width: 40px;
`;
